import { Plus, Search, X } from "lucide-react";

export interface StatusFilterOption {
  label: string;
  value: string;
}

interface MasterTableHeaderProps {
  title: string;
  description: string;

  canCreate?: boolean;
  addButtonText?: string;
  onAdd?: () => void;

  searchPlaceholder?: string;
  searchQuery?: string;
  setSearchQuery?: (value: string) => void;

  showDropdownFilter?: boolean;
  dropdownValue?: string;
  dropdownOptions?: StatusFilterOption[];
  onDropdownChange?: (value: string) => void;

  showStatusFilter?: boolean;
  statusFilter?: string;
  statusOptions?: StatusFilterOption[];
  onStatusChange?: (value: string) => void;

  statusPlaceholder?: string;
  onClearFilters?: () => void;
  showClearFilters?: boolean;
}

export default function MasterTableHeader({
  title,
  description,
  canCreate = false,
  addButtonText = "Add New",
  onAdd,

  searchPlaceholder = "Search...",
  searchQuery,
  setSearchQuery,

  showStatusFilter = false,
  statusFilter = "",
  statusOptions = [],
  onStatusChange,

  showDropdownFilter = true,
  dropdownValue = "",
  onDropdownChange,
  showClearFilters = false,
  onClearFilters,
}: MasterTableHeaderProps) {
    const statusFilterOptions = [
    { value: "True", label: "Active" },
    { value: "False", label: "Inactive" },
  ]
  return (
    <div
      className="px-6 py-4 rounded-t-xl shadow-lg"
      style={{
        background:
          "linear-gradient(135deg, #2d3440 0%, #535c6b 100%)",
      }}
    >
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-white">
            {title}
          </h2>

          <p className="text-white text-sm mt-1">
            {description}
          </p>
        </div>

        {canCreate && (
          <button
            onClick={onAdd}
            className="flex items-center gap-2 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white font-semibold py-2.5 px-4 rounded-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
          >
            <Plus className="w-5 h-5" />
            {addButtonText}
          </button>
        )}
      </div>

      <div className="relative mt-3">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/70" />

        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full pl-9 pr-8 py-1.5 text-sm bg-white/20 text-white placeholder-white/60 border border-white/30 rounded-lg focus:outline-none focus:bg-white/30"
        />

        {searchQuery && (
          <button
            onClick={() => setSearchQuery("")}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-white/70 hover:text-white"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      <div className="mt-3 flex flex-row justify-end items-center gap-4">
  {/* Dropdown */}
  {showDropdownFilter && (
    <select
      value={dropdownValue}
      onChange={(e) => onDropdownChange?.(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-400"
    >
      <option value="">Select Status</option>

      {statusFilterOptions?.map((item) => (
        <option key={item.value} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  )}

  {/* Button Filter */}
  {showStatusFilter && (
    <div className="inline-flex bg-white/10 rounded-xl p-1 border border-white/20">
      {statusOptions?.map((item) => (
        <button
          key={item.value}
          onClick={() => onStatusChange?.(item.value)}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
            statusFilter === item.value
              ? "bg-white text-slate-800 shadow"
              : "text-white hover:bg-white/10"
          }`}
        >
          {item.label}
        </button>
      ))}
    </div>
  )}
   {showClearFilters && (dropdownValue || statusFilter || searchQuery) && (
  <button
    onClick={onClearFilters}
    className="px-4 py-2 rounded-lg border border-white/30 text-white hover:bg-white/20 transition"
  >
    Clear Filters
  </button>
)}
</div>
    </div>
  );
}